/* eslint-disable no-debugger */
import React, { useState, useEffect } from "react";

import { PDFExport, savePDF } from "@progress/kendo-react-pdf";

import useImxCerts from "./UseImxCerts";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";

const ImxCerts = ({ reportInfoId, reportParameters }) => {
  const {
    reportData,
  } = useImxCerts(reportInfoId, reportParameters);

  const [loading, setLoading] = useState(false);

  const container = React.useRef(null);
  const pdfExportComponent = React.useRef(null);

  const ImxImage = "/IMXCertificateBackgroundImage-updated.gif";
  const ImrImage = "/IMRCertificate_Background.gif";

  const exportPDFWithComponent = async () => {
    setLoading(true);
      
    try {
      if (pdfExportComponent.current) {
        pdfExportComponent.current.save();
      }
      } finally {
        setLoading(false);
      }
  };

  return (
    <div>
      <h3 className="text-center">My IMX / IMR Certificate</h3>
      <hr className="k-hr" />

      <button type="button" onClick={exportPDFWithComponent}>
        Export to PDF
      </button> 
      <span style={{color: 'charcoal', fontStyle: 'italic'}}>&nbsp;&nbsp;&nbsp;This may take some time, consider narrowing your search parameters.</span>
      
      <PDFExport
        ref={pdfExportComponent}
        scale={0.68}
        landscape={true}
        paperSize="Letter"
        margin="1cm"
        fileName={`Report for ${new Date().getFullYear()}`}
        author="USAS Team"
        onExportComplete={() => setLoading(false)}
      >
        <div ref={container}>
          {reportData.map((cert, idx) => (
            <div key={idx} style={{ marginBottom: "40px" }}>
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  height={800}
                  width={1100}
                  // src="/IMXCertificateBackgroundImage-updated.gif"
                  src={cert.seasonname.includes('IMR') ? ImrImage : ImxImage}
                  // src={ImrImage}
                  alt={cert.seasonname.includes('IMR') ? "IMR Certificate Background" : "IMX Certificate Background"}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '65%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: 'black',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontFamily: 'Arial'
                  }}
                >
                  <div style={{ fontFamily: 'Arial' }}>{cert.firstname} {cert.lastname}</div>
                  <br />
                  <div style={{ fontSize: '12px', fontFamily: 'Arial' }}>
                    Of {cert.clubname} Has achieved an {cert.seasonname.includes('IMR') ? "I.M. Ready" : "I.M. Extreme"} score of
                  </div>
                  <br />
                  <div style={{ fontSize: '32px', fontFamily: 'Arial' }}>{cert.totalScore}</div>
                  <br />
                  <div style={{ fontSize: '12px', fontFamily: 'Arial' }}>for the {cert.imxage} year old age group during the {cert.seasonname} season</div>
                  <br />
                  <div style={{ display: 'flex', flexDirection: 'row', marginTop: '4px', gap: '60px', justifyContent: 'center' }}>
                    <div style={{ fontSize: '12px', fontFamily: 'Arial' }}>
                      <table style={{ borderCollapse: 'collapse', fontFamily: 'Arial' }}>
                        <tbody>
                          <tr>
                            <td style={{width: '100px', fontFamily: 'Arial'}}>National Rank:</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.nationalrank} of&nbsp;</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.nationaltotal} ({cert.nationalpercentile} percentile) </td>
                          </tr>
                          <tr>
                            <td style={{width: '100px', fontFamily: 'Arial'}}>Zone Rank:</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.zonerank} of&nbsp;</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.zonetotal} ({cert.zonepercentile} percentile) </td>
                          </tr>
                          <tr>
                            <td style={{width: '100px', fontFamily: 'Arial'}}>LSC Rank:</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.lscrank} of&nbsp;</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.lsctotal} ({cert.lscpercentile} percentile) </td>
                          </tr>
                          <tr>
                            <td style={{width: '100px', fontFamily: 'Arial'}}>Club Rank:</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.clubrank} of&nbsp;</td>
                            <td style={{fontFamily: 'Arial'}}>{cert.clubtotal} ({cert.clubpercentile} percentile) </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style={{ fontSize: '12px', fontFamily: 'Arial' }}>
                      <table style={{ borderCollapse: 'collapse', fontFamily: 'Arial' }}>
                        <tbody>
                          {cert.imxDetail.map((event, eventIdx) => (
                            <tr key={event.event || eventIdx}>
                              <td style={{width: '100px', fontFamily: 'Arial'}}>{event.eventCode}</td>
                              <td style={{width: '70px', fontFamily: 'Arial'}}>{event.imxPoints}</td>
                              <td style={{fontFamily: 'Arial'}}>{event.swimTime}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </PDFExport>
      <PopUpModal
        displayPopUp={loading}
        maxWidth={250}
        title="Loading..."
        widthPct={50} />
    </div>
  );
};

export default ImxCerts;